import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import App from "./App.vue";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { onMounted, onUnmounted, watch, ref, Ref } from "vue";
import {
  listenToDisplayName,
  listenToProfilePic,
  listenToRating,
  updateDisplayName,
  updateProfilePic,
  updateRating,
} from "./firebase/userInfo";
import { useUserInfoStore } from "./stores/userInfoStore";
import { useRouter } from "vue-router";
import { useGameStore } from "./stores/gameStore";
import { joinClosedGame } from "./firebase/database";
import { moveMadeListener } from "./firebase/moves";
import firebase from "firebase/compat";
import Unsubscribe = firebase.Unsubscribe;


export default /*#__PURE__*/_defineComponent({
  __name: 'VueRoot',
  setup(__props) {

const userStore = useUserInfoStore();
const gameStore = useGameStore();
const router = useRouter();
const unsubscribes: Unsubscribe[] = [];
const userWatchers: Ref<CallableFunction[]> = ref([]);
const gameWatchers: Ref<CallableFunction[]> = ref([]);

onMounted(() => {
  onAuthStateChanged(getAuth(), (user) => {
    console.log("Auth State Change detected");
    if (!user) {
      for (const watcher of [
        ...gameWatchers.value,
        ...userWatchers.value,
        ...unsubscribes,
      ]) {
        watcher();
      }
      userWatchers.value = [];
      userStore.logOut();
      return;
    } else {
      console.log("Watching changes to user info");
      unsubscribes.push(listenToDisplayName(user.uid, userStore));
      unsubscribes.push(listenToProfilePic(user.uid, userStore));
      unsubscribes.push(listenToRating(user.uid, userStore));
      userWatchers.value.push(
        watch(
          () => userStore.rating,
          (newRating) => updateRating(user.uid, newRating)
        )
      );
      userWatchers.value.push(
        watch(
          () => userStore.displayName,
          (newDisplayName) => updateDisplayName(user.uid, newDisplayName)
        )
      );
      userWatchers.value.push(
        watch(
          () => userStore.profilePic,
          (newProfilePic) => updateProfilePic(user.uid, newProfilePic)
        )
      );
      userStore.logIn(user.uid);

      gameWatchers.value.push(
        watch(
          () => router.currentRoute.value.params.id,
          (id) => {
            // Stop listening to all old gameWatchers
            for (const watcher of gameWatchers.value) {
              watcher();
            }
            gameWatchers.value = [];
            gameStore.setGameId(null);
            if (!id || Array.isArray(id)) return;
            console.log("Navigated to the game page");
            if (id == "local") {
              console.log("Playing a local game");
              gameStore.initializeLocalGame();
              return;
            }
            console.log("Playing an online game");

            gameStore.setGameId(id);
            gameStore.setWaitingMessage("Loading game...");

            console.log("Calling join closed game function");
            joinClosedGame(gameStore, userStore).then(() => {
              gameWatchers.value.push(
                moveMadeListener(id, (moveString: string) => {
                  gameStore.processMove(moveString);
                })
              );
            });
          },
          { deep: true, immediate: true }
        )
      );
    }
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(App))
}
}

})